import { useCallback, useRef, useState } from "react";
import axios from "axios";
import useIframeMessageHandler from "./useIframeMessageHandler";

const useHandwrittenCard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [billingPageUrl, setBillingPageUrl] = useState(null);
  const [error, setError] = useState(null);
  const [isAddressPickerOpen, setIsAddressPickerOpen] = useState(false);
  const iframeRef = useRef(null);

  const closeModal = useCallback(() => {
    setIsLoading(false);
    setIframeUrl(null);
    setBillingPageUrl(null);
    setError(null);
  }, []);

  useIframeMessageHandler({ iframeUrl, iframeRef, billingPageUrl, onClose: closeModal });

  const fetchIframeUrl = useCallback(async (personUuid, addressId) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get(`/api/v4/inked/iframe_url`, {
        params: {
          person_uuid: personUuid,
          address_id: addressId,
        },
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": window.ReactOnRails?.authenticityToken(),
        },
      });
      const { iframe_url: url, billing_page_url: billingUrl } = response.data;
      setIframeUrl(url);
      setBillingPageUrl(billingUrl);
    } catch (err) {
      const errorMessage =
        err.response?.data?.error ||
        "Handwritten card service is temporarily unavailable. Please try again later.";
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const openAddressPicker = useCallback(() => {
    setIsAddressPickerOpen(true);
  }, []);

  const closeAddressPicker = useCallback(() => {
    setIsAddressPickerOpen(false);
  }, []);

  return {
    isLoading,
    iframeUrl,
    iframeRef,
    error,
    isAddressPickerOpen,
    isModalOpen: isLoading || !!iframeUrl || !!error,
    fetchIframeUrl,
    closeModal,
    openAddressPicker,
    closeAddressPicker,
  };
};

export default useHandwrittenCard;
